import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {FieldArray, FormikProvider} from 'formik';
import classnames from 'classnames';
import {useCreatePriceQuoteGIContext} from '../../contexts/CreatePriceQuoteGIContext';
import EditableRow from '../EditableRow';
import ButtonAction from '../../../_common/components/ButtonAction';
import {headerCellsArrayCommonDocs} from '../../../CustomerDetails/constants/gridColumns';
import {rowValuesSetCommonDocs} from '../../../CustomerDetails/constants/valuesSets';
import {rowFieldsSetCommonDocs} from '../../../CustomerDetails/constants/fieldSets';
import styles from './styles.module.scss';
import themeStyles from "../../../_common/styles/theme.module.scss";
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";

interface GridEditableRowsProps {
  containerClassnames?: string;
}

const GridEditableRows: React.FC<GridEditableRowsProps> = ({containerClassnames = ''}) => {
  const {formik} = useCreatePriceQuoteGIContext();
  const {values} = formik;
  const {isGlassTheme} = useGlobalContext();

  const mapHeaderCells = (item: {label: string | ReactElement; showMarkNecessary?: boolean; customItemStyles?: string}, index: number) => {
    return (
      <div key={index} className={classnames(styles.headerCell, item.customItemStyles)}>
        {item.label}
        {item.showMarkNecessary && <span className="text-danger">*</span>}
      </div>
    );
 };

  return (
    <div className={classnames(styles.gridEditableRows, containerClassnames)}>
      <div className={classnames(styles.header,
        isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
        isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground
      )}>
        {headerCellsArrayCommonDocs.map(mapHeaderCells)}
      </div>

      <FormikProvider value={formik}>
        <FieldArray name="rowsCommonDocs">
          {({remove, push }) => (
            <>
              <div className={styles.gridBody}>
                {values.rowsCommonDocs.length > 0 &&
                  values.rowsCommonDocs.map((_sets: any, index: number) => (
                    <EditableRow
                      key={index}
                      fieldsSet={rowFieldsSetCommonDocs(index)}
                      values={values}
                      removeRow={() => remove(index)}
                      index={index}
                    />
                  ))}
              </div>
            </>
          )}
        </FieldArray>
      </FormikProvider>
    </div>
  );
};

export default GridEditableRows;